module.exports = __webpack_public_path__ + "static/img/c2.f2c5029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cloud/c2.png
// module id = 7vOX
// module chunks = 0